<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :icon="page.icon" :breadcrumbs="breadcrumbs"></BaseBreadcrumb>
    <v-row>
      <v-col cols="12" sm="12" lg="12">
        <TheCotizacionesTable />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "Cotizaciones",
  components: {
    TheCotizacionesTable: () =>
      import(
        "@/components/dashboardComponents/TheCotizacionesTable"
      ),
  },
  data: () => ({
    page: {
      title: "Cotizaciones"
    },
    elementVisible: false,
    breadcrumbs: [
      {
        text: "Home",
        disabled: false,
        href: "/dashboard/index/"
      },
      {
        text: "Cotizaciones",
        disabled: true,
        href: "/dashboard/cotizaciones/"
      }
    ]
  })
};
</script>
